<template>
	<v-row fill-height>
		<v-col cols="4">
			<UserList :users="users" @view="showUser" />

			<v-btn color="success" x-large class="mt-2" block @click="newUser">
				<v-icon left>mdi-account-plus</v-icon> Add User
			</v-btn>
		</v-col>

		<v-col cols="8">
			<UserDetails v-bind="activeUser" @edit="editUser" @remove="removeUser" />
		</v-col>
	</v-row>
</template>

<script>
import UserList from '@/components/n-collections/UserList'
import UserDetails from '@/components/admin/UserDetails'

import UserService from '@/services/UserService'

import Dialog from '@/components/dialogs/DialogEdit'
import UserForm from '@/components/dialogs/forms/UserForm'

import Messages from '@/helpers/message-helper'

export default {
	name: 'AdminUsers',

	components: {
		UserList,
		UserDetails,
	},
	data() {
		return {
			users: [],
			activeUser: {},
		}
	},
	async created() {
		this.users = await UserService.getAll()
	},
	methods: {
		newUser() {
			this.showDialog()
		},
		editUser() {
			this.showDialog(this.activeUser)
		},
		async showUser(user) {
			this.activeUser = user
		},
		async removeUser() {
			const { Username } = this.activeUser
			let result = await UserService.removeUser(Username)
			if (!result) return

			const index = this.users.findIndex((e) => e.Username == Username)
			this.users.splice(index, 1)

			this.activeUser = {}
		},
		async showDialog(data) {
			var isNew
			if (!data) {
				data = { Username: '', Attributes: { name: '', email: ''} }
				isNew = true
			} else {
				isNew = false
			}
			
			var currentUserName = data.Attributes.name

			var result = await this.$dialog.showAndWait(Dialog, {
				title: 'User Management',
				component: UserForm,
				data,
				icon: false,
				width: this.dialogWidth || 600,
				hideDelete: true,
				disableUsername: !isNew,
			})

			// If action is not save, the dialog was cancelled
			if (!result || result.action != 'save') return
			const { dialogData } = result
			dialogData.currentUserName = currentUserName


			try {
				// Choose service call based on action
				var saveResult, message

				if (isNew) {
					saveResult = await UserService.addUser(dialogData)
					this.users.push(saveResult)
					message = 'inserted!'
				} else {
					saveResult = await UserService.saveUser(dialogData)
					const index = this.users.findIndex(
						(e) => e.Username == dialogData.Username
					)

					this.activeUser = dialogData
					this.$set(this.users, index, dialogData)
					
					message = 'saved'
				}
			} catch (error) {
				this.$emit('show-message', Messages.ERROR(error))
			}
		},
	},
}
</script>

<style lang="scss" scoped>
</style>